(() => {
  'use strict';

  const FREE_SHIPPING_TARGET = 13000; // 130 TND in cents
  const COMPONENT_ATTR = 'data-sympatico-free-shipping-130';
  let refreshTimer;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      try {
        return window.Shopify.formatMoney(cents, window.money_format);
      } catch (e) {}
    }
    const value = cents / 100;
    return `${Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2)} DT`;
  }

  function createComponent(location) {
    const el = document.createElement('div');
    el.setAttribute(COMPONENT_ATTR, location);
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = `
      <div class="sympatico-free-shipping__message"></div>
      <div class="sympatico-free-shipping__track" aria-hidden="true">
        <div class="sympatico-free-shipping__bar"></div>
      </div>`;
    return el;
  }

  function ensureStyles() {
    if (document.getElementById('sympatico-free-shipping-130-style')) return;
    const style = document.createElement('style');
    style.id = 'sympatico-free-shipping-130-style';
    style.textContent = `
      [${COMPONENT_ATTR}] { margin: 12px 15px 16px; padding: 12px 14px; border-radius: 8px; background: #f7f7f7; text-align: center; font-size: 13px; line-height: 1.4; }
      [${COMPONENT_ATTR}="main"] { max-width: 100%; margin: 0 0 18px; }
      .sympatico-free-shipping__message { font-weight: 600; }
      .sympatico-free-shipping__track { height: 6px; margin-top: 9px; border-radius: 999px; background: #e4e4e4; overflow: hidden; }
      .sympatico-free-shipping__bar { width: 0%; height: 100%; border-radius: inherit; background: #111; transition: width .3s ease; }
      [${COMPONENT_ATTR}].is-free .sympatico-free-shipping__track { display: none; }
      @media (max-width: 767px) { [${COMPONENT_ATTR}] { margin: 10px 12px 14px; padding: 11px 12px; font-size: 13px; } [${COMPONENT_ATTR}="main"] { margin: 0 0 15px; } }
    `;
    document.head.appendChild(style);
  }

  function ensureMounts() {
    ensureStyles();

    const drawer = document.querySelector('.halo-cart-sidebar .halo-sidebar-wrapper');
    if (drawer && !drawer.querySelector(`[${COMPONENT_ATTR}="drawer"]`)) {
      drawer.prepend(createComponent('drawer'));
      scheduleRefresh(20);
    }

    if (document.body.classList.contains('template-cart')) {
      const main = document.querySelector('#MainContent');
      if (main && !main.querySelector(`[${COMPONENT_ATTR}="main"]`)) {
        const target = main.querySelector('.cart-container, .container, cart-items') || main.firstElementChild || main;
        target.prepend(createComponent('main'));
        scheduleRefresh(20);
      }
    }
  }

  function render(cart) {
    const total = Number(cart && cart.total_price) || 0;
    const itemCount = Number(cart && cart.item_count) || 0;
    document.querySelectorAll(`[${COMPONENT_ATTR}]`).forEach((el) => {
      if (!itemCount) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      const message = el.querySelector('.sympatico-free-shipping__message');
      const bar = el.querySelector('.sympatico-free-shipping__bar');
      if (total >= FREE_SHIPPING_TARGET) {
        el.classList.add('is-free');
        message.innerHTML = '🎉 <strong>Livraison gratuite débloquée !</strong>';
        if (bar) bar.style.width = '100%';
      } else {
        el.classList.remove('is-free');
        const remaining = FREE_SHIPPING_TARGET - total;
        message.innerHTML = `🚚 Plus que <strong>${formatMoney(remaining)}</strong> pour profiter de la livraison gratuite`;
        if (bar) bar.style.width = `${Math.max(0, Math.min(100, (total / FREE_SHIPPING_TARGET) * 100))}%`;
      }
    });
  }

  async function refresh() {
    try {
      ensureMounts();
      const response = await fetch(`${window.routes?.root || ''}/cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      render(await response.json());
    } catch (e) {}
  }

  function scheduleRefresh(delay = 250) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay);
  }

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function' && !window.__sympaticoFreeShippingFetchPatched) {
    window.__sympaticoFreeShippingFetchPatched = true;
    window.fetch = function(...args) {
      const request = args[0];
      const url = typeof request === 'string' ? request : (request && request.url) || '';
      const result = originalFetch.apply(this, args);
      if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) {
        result.then(() => scheduleRefresh(180)).catch(() => {});
      }
      return result;
    };
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-remove], .cart-remove, .quantity__button, .btn-quantity, [data-quantity-change]')) {
      scheduleRefresh(500);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"], .quantity__input, [data-cart-quantity]')) {
      scheduleRefresh(500);
    }
  }, true);

  ['cart:updated', 'cart-updated', 'cart:refresh', 'cart:change'].forEach((name) => {
    document.addEventListener(name, () => scheduleRefresh(100));
  });

  const observer = new MutationObserver(() => ensureMounts());

  function init() {
    ensureMounts();
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
